export const NAME = 'events'
export const ITEMS_PER_PAGE = 8
